import { Injectable } from '@angular/core';
import { AgentsCount, AssignedCounts, DepartmentLoad, DepartmentLoadsModel, QueueCounts, StatusCount, StatusCounts } from 'common/api/models/department-loads.model';
import { StatusTypes } from 'common/common/constants/status-types';
import { Summary } from 'components/queue-view/live-workload-tab/models/department-item';
import { ServiceColumn } from 'components/queue-view/live-workload-tab/models/column-config';

@Injectable({
  providedIn: 'root'
})
export class DepartmentListTabService {

  public getAgentCounts(statusCounts: StatusCounts): [number, number] {
    if (statusCounts) {
      const serviceType = Object.keys(statusCounts)
        .find(serviceType => statusCounts[serviceType]);

      if (serviceType) {
        const count: StatusCount = statusCounts[serviceType];
        let signedInAgentsCount = 0;
        signedInAgentsCount += count[StatusTypes.AWAY] || 0;
        signedInAgentsCount += count[StatusTypes.AVAILABLE] || 0;

        let agentsCount = signedInAgentsCount;
        agentsCount += count[StatusTypes.OFFLINE] || 0;

        return [agentsCount, signedInAgentsCount];
      }
    }

    return [0, 0];
  }

  public getSummaryValues(departmentLoadsModel: DepartmentLoadsModel, services: ServiceColumn[]): Summary {
    let totalOperatorStatusSummary;
    let totalStatusCounts;

    const totalAssignedCount: AssignedCounts = this._calculateTotalAssignedCount(departmentLoadsModel.departmentLoads, services);
    const totalQueueCount: QueueCounts = this._calculateTotalQueueCount(departmentLoadsModel.departmentLoads, services);

    if (departmentLoadsModel.operatorStatusSummary) {
      totalOperatorStatusSummary = this._calculateStatusSummary(departmentLoadsModel.operatorStatusSummary);
      totalStatusCounts = this._calculateStatusCountsSummary(departmentLoadsModel.operatorStatusSummary, services);
    }

    return {
      assignedCounts: totalAssignedCount,
      queueCounts: totalQueueCount,
      statusCounts: totalStatusCounts,
      ...totalOperatorStatusSummary
    };
  }

  private _calculateTotalAssignedCount(departmentLoads: Record<string, DepartmentLoad>, services: ServiceColumn[]): AssignedCounts {
    return Object.keys(departmentLoads).reduce((assignedCounts, departmentId) => {
      const departmentAssignedCounts = departmentLoads[departmentId].assignedCounts;
      services.forEach(service => {
        if (departmentAssignedCounts && departmentAssignedCounts[service.serviceType]) {
          if (!assignedCounts[service.serviceType]) {
            assignedCounts[service.serviceType] = {assigned: 0, bot: 0};
          }
          assignedCounts[service.serviceType].assigned = (assignedCounts[service.serviceType].assigned || 0) + (departmentAssignedCounts[service.serviceType].assigned);
          assignedCounts[service.serviceType].bot = (assignedCounts[service.serviceType].bot || 0) + (departmentAssignedCounts[service.serviceType].bot);
        }
      });
      return assignedCounts;
    }, <AssignedCounts>{});
  }

  private _calculateTotalQueueCount(departmentLoads: Record<string, DepartmentLoad>, services: ServiceColumn[]): QueueCounts {
    return Object.keys(departmentLoads).reduce((queueCounts, departmentId) => {
      const departmentQueueCounts = departmentLoads[departmentId].queueCounts;
      services.forEach(service => {
        if (departmentQueueCounts) {
          queueCounts[service.serviceType] = (queueCounts[service.serviceType] || 0) + (departmentQueueCounts[service.serviceType] || 0);
        }
      });
      return queueCounts;
    }, <QueueCounts>{});
  }

  private _calculateStatusSummary(operatorStatusSummary: StatusCounts): AgentsCount {
    let [totalAgentsCount, totalSignedInAgentsCount] = this.getAgentCounts(operatorStatusSummary);
    return {
      agentsCount: totalAgentsCount,
      signedInAgentsCount: totalSignedInAgentsCount
    };
  }

  private _calculateStatusCountsSummary(operatorStatusSummary: StatusCounts, services: ServiceColumn[]): StatusCounts {
    return services.reduce((statusCounts, service) => ({
      ...statusCounts,
      [service.serviceType]: operatorStatusSummary[service.serviceType]
    }), {});
  }
}
